import { isEmptyOrSpace } from '../../webmodule-common/other/ui/string-helper-functions';
import { isValidV6ConfigVersion, v6Util } from '../../webmodule-common/interop/interfaces/v6-config';

export function getV6QuoteItemFrameDimensions(v6QuoteItem?: object | null): string {
  if (!v6QuoteItem || !isValidV6ConfigVersion()) return '';

  const displayString = v6Util().getCustomFrameDimensions(v6QuoteItem);
  if (displayString != undefined) return displayString;
  const values = v6Util().getFrameDimensions(v6QuoteItem);
  const displayWidth = values?.displayWidth ? `${values.displayWidth} (W)` : `${values?.width ?? 0} (W)`;
  const displayHeight = values?.displayHeight ? `${values.displayHeight} (H)` : `${values?.height ?? 0} (H)`;

  if (values.width && values.height) {
    return values.displayHeightFirst ? `${displayHeight} x ${displayWidth}` : `${displayWidth} x ${displayHeight}`;
  } else if (values.height) return `"${displayHeight}`;
  else if (values.width) return `${displayWidth}`;
  else return '';
}

export function getV6QuoteItemSubtitleOrFrameDimensions(v6QuoteItem?: object | null): string {
  if (!v6QuoteItem || !isValidV6ConfigVersion()) return '';

  // The table one-liner prefers the item's own subtitle over any dimension text. A v6config
  // bundle older than v3.0.12 has no getFrameSubtitle, so those tenants fall through to the
  // dimension text unchanged.
  const subtitle = v6Util().getFrameSubtitle?.(v6QuoteItem);
  if (!isEmptyOrSpace(subtitle)) return subtitle ?? '';

  return getV6QuoteItemFrameDimensions(v6QuoteItem);
}
